import { render } from "./ApiDashboard.vue?vue&type=template&id=85f99232&scoped=true"
import script from "./ApiDashboard.vue?vue&type=script&lang=js"
export * from "./ApiDashboard.vue?vue&type=script&lang=js"

import "./ApiDashboard.vue?vue&type=style&index=0&id=85f99232&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f99232"]])

export default __exports__